(function(api) {
	api.ABarKodObrisi = ABarKodObrisi;
	api.ABarKodGetLabelCaption = ABarKodGetLabelCaption;
	api.GetGodinaSkladisteVpDokumNaziv = GetGodinaSkladisteVpDokumNaziv;
	api.GetDStavkeFields = GetDStavkeFields;
	api.ArtiklById = ArtiklById;
	api.GetDisplayStanja = GetDisplayStanja;
	api.GetDStavkeBrisanjeInteract = GetDStavkeBrisanjeInteract;
	api.GetDStavkeRacunBrisanjeInteract = GetDStavkeRacunBrisanjeInteract;
	api.DStavkeObrisi = DStavkeObrisi;
	api.DStavkeObrisiList = DStavkeObrisiList;
	api.DStavkeCopy = DStavkeCopy;
	api.DStavkePaste = DStavkePaste;
	api.DopustenoNastimavanjePoreza = DopustenoNastimavanjePoreza;
	api.NastimajPorez = NastimajPorez;
	api.GetDZaglavBrisanjePitanje = GetDZaglavBrisanjePitanje;
	api.DZaglavObrisi = DZaglavObrisi;
	api.DZaglavGenerirajZahtINarIzRdn = DZaglavGenerirajZahtINarIzRdn;
	api.AGrupa1Obrisi = AGrupa1Obrisi;
	api.AsortimanObrisi = AsortimanObrisi;
	api.ModelObrisi = ModelObrisi;
	api.VoziloObrisi = VoziloObrisi;
	api.VoziloGetLabelCaption = VoziloGetLabelCaption;
	api.PlacenoObrisi = PlacenoObrisi;
	api.GetPlacRateFields = GetPlacRateFields;
	api.GetCStavkeFields = GetCStavkeFields;
	api.CStavkeKontrolaGrupaArtikala = CStavkeKontrolaGrupaArtikala;
	api.ProvjeraPreklapanjaStavki = ProvjeraPreklapanjaStavki;
	api.UpisPremaPrvojStavci = UpisPremaPrvojStavci;
	api.CStavkeGetPopisPoljaZaPrikaz = CStavkeGetPopisPoljaZaPrikaz;
	api.CjenikSeUnosiPrekoAG1 = CjenikSeUnosiPrekoAG1;
	api.CjenikGetPopisPoljaZaPrikaz = CjenikGetPopisPoljaZaPrikaz;
	api.CjenikObrisi = CjenikObrisi;
	api.CParGetPopisPoljaZaPrikaz = CParGetPopisPoljaZaPrikaz;
	api.CParPartneriZaSkupnoFakturiranjeWarrning = CParPartneriZaSkupnoFakturiranjeWarrning;
	api.CParObrisi = CParObrisi;
	api.DStavkeSetAfterPolje = DStavkeSetAfterPolje;
	api.DZaglavSetAfterPolje = DZaglavSetAfterPolje;
	api.OdjavaSSetAfterPolje = OdjavaSSetAfterPolje;
	api.CStavkeObrisi = CStavkeObrisi;
	api.DZaglavImaUDigitalnojArhivi = DZaglavImaUDigitalnojArhivi;
	api.VpStatusDigitalnoArhivirati = VpStatusDigitalnoArhivirati;
	api.GetDZaglavZakljucan = GetDZaglavZakljucan;
	api.GetDZaglavNoviCaptionByPK = GetDZaglavNoviCaptionByPK;
	api.VpOrganPObrisi = VpOrganPObrisi;
	api.VpStatusPObrisi = VpStatusPObrisi;
	api.GetGodinaZaPozicijuIzvore = GetGodinaZaPozicijuIzvore;	
	api.InitMogucePromjeneVpStatusa = InitMogucePromjeneVpStatusa;
	api.MogucaPromjenaVpStatusa = MogucaPromjenaVpStatusa;
	api.PromijeniVpStatus = PromijeniVpStatus;
	api.VpStatusGetObavijest = VpStatusGetObavijest;
	api.KontoRizById = KontoRizById;
	api.GetUpozorenjeOPartneruZaNoviProdajniIliPredprodajniDokument = GetUpozorenjeOPartneruZaNoviProdajniIliPredprodajniDokument;
	api.PartnerJeMaticni = PartnerJeMaticni;
	api.GetArtiklAfterA2Grupa1 = GetArtiklAfterA2Grupa1;
	api.ArtiklValidate = ArtiklValidate;
	api.ArtiklGetNovaSifra = ArtiklGetNovaSifra;
	api.RjesenjeById = RjesenjeById;
	api.OdjavaPopuni = OdjavaPopuni;
	api.GetOdjavaSFields = GetOdjavaSFields;
	api.GetOdjavaSArtiklDodatno = GetOdjavaSArtiklDodatno;
	api.InvenObrisi = InvenObrisi;
	api.GetInvenSFields = GetInvenSFields;
	api.InvenSSetAfterPolje = InvenSSetAfterPolje;
	api.InvenSObrisi = InvenSObrisi;
	api.GetInvenLFields = GetInvenLFields;
	api.InvenLObrisi = InvenLObrisi;
	api.DohvatiIznoseDStavke = DohvatiIznoseDStavke;
	api.GetDZagDZagDokumentiCaption = GetDZagDZagDokumentiCaption;
	api.UpisiVpOvlastenjaZaVrstaGrupaKor = UpisiVpOvlastenjaZaVrstaGrupaKor;
	api.ProvjeraPreklapaSe = ProvjeraPreklapaSe;
	api.MPCijenaValidate = MPCijenaValidate;
	api.SetPCijenaAfterMPCijena = SetPCijenaAfterMPCijena;
	api.GetNapomena2KontoRiznica = GetNapomena2KontoRiznica;
	api.CStavkeUpisUArtikl = CStavkeUpisUArtikl;
	api.CStavkeSetAfterPolje = CStavkeSetAfterPolje;
	api.SetAfterCParOdabir = SetAfterCParOdabir;
	api.DohvatiNaplatneUredjaje = DohvatiNaplatneUredjaje;
	api.DefaultNaplatniRacun = DefaultNaplatniRacun;
	api.GetDStavkeRacunSifarnikCaption = GetDStavkeRacunSifarnikCaption;
	api.ZakljucanPoVpStatusu = ZakljucanPoVpStatusu;
	api.DStavkeUpisUArtikl = DStavkeUpisUArtikl;
	api.DZaglavIzmijeniBiljesku = DZaglavIzmijeniBiljesku;
	api.RacunIzmijeniBiljesku = RacunIzmijeniBiljesku;
	api.VpOvlastenjeObrisi = VpOvlastenjeObrisi;	
	api.DohvatiPitanjeZaPrijepisStanja = DohvatiPitanjeZaPrijepisStanja;
	api.DStavkeUpisiArtikleSaStanja = DStavkeUpisiArtikleSaStanja;
	api.DohvatiPostoMarzeDStavke = DohvatiPostoMarzeDStavke;
	api.DohvatiMasuAOpisDStavke = DohvatiMasuAOpisDStavke;
	api.GetKolicineDStavke = GetKolicineDStavke;
	api.RacunSetAfterPolje = RacunSetAfterPolje;	
	api.sljedecaGodinaEnabled = SljedecaGodinaEnabled;
	api.GetRjRedakTekst = GetRjRedakTekst;
	api.RacunProvjeriVAT = RacunProvjeriVAT;
	api.GetKZaglavBrisanjePitanje = GetKZaglavBrisanjePitanje;	
	api.KZaglavObrisi = KZaglavObrisi;	
	api.GetKStavkeFields = GetKStavkeFields;
	api.GetKZaglavZakljucan = GetKZaglavZakljucan;	
	api.KStavkeObrisiList = KStavkeObrisiList;
	api.GetKolicineKStavke = GetKolicineKStavke;	
	api.RacunImaUDigitalnojArhivi = RacunImaUDigitalnojArhivi;	
	api.GetRacunZakljucan = GetRacunZakljucan;
	api.DStavkeRacunObrisiList = DStavkeRacunObrisiList;
	api.GetERacunPitanjeSlanje = GetERacunPitanjeSlanje;
	api.ERacunJeMogucePoslati = ERacunJeMogucePoslati;
	api.GetERacunPriviciIzDA = GetERacunPriviciIzDA;	
	api.PodaciZaEdiVisible = PodaciZaEdiVisible;	
	api.PosaljiERacunVp = PosaljiERacunVp;	
	api.GetERacunPitanjeMultiSlanje = GetERacunPitanjeMultiSlanje;		
	api.AzurirajParametreZaSlanjePremaPodacimaUPartneruClick = AzurirajParametreZaSlanjePremaPodacimaUPartneruClick;
	api.ERacunProvjeraStatusa = ERacunProvjeraStatusa;
	api.ERacunPrisilnoSlanje = ERacunPrisilnoSlanje;
	api.GetRacunBrisanjePitanje = GetRacunBrisanjePitanje;
	api.RacunMultiBrisanje = RacunMultiBrisanje;
	api.RacunBrisanjeList = RacunBrisanjeList;
	api.ERacunOpoziv = ERacunOpoziv;
	api.ERacunPonistiOznakuERacunPoslan = ERacunPonistiOznakuERacunPoslan;	
	api.ERacunPosaljiPrimateljuObavijestOPrimljenomERacunu = ERacunPosaljiPrimateljuObavijestOPrimljenomERacunu;	
	api.ERacunIskljuciSlanjeERacunaZaTrenutniRacun = ERacunIskljuciSlanjeERacunaZaTrenutniRacun;
	api.ERacunOznaciDaJeRacunDostavljen = ERacunOznaciDaJeRacunDostavljen;
	api.ERacunProvjeraStatusaZaRazdoblje = ERacunProvjeraStatusaZaRazdoblje;
	api.ERacunProvjeriStatusVpRacunRazdoblje = ERacunProvjeriStatusVpRacunRazdoblje;	
	api.MoguceKopiranjeRacuna = MoguceKopiranjeRacuna;
	api.RacunValidate = RacunValidate;
	api.RacunFiskalizacijaOznacenogRacuna = RacunFiskalizacijaOznacenogRacuna;
	api.PripremiRacunZaFiskalizaciju = PripremiRacunZaFiskalizaciju;
	api.GetListaNefiskaliziranihRacuna = GetListaNefiskaliziranihRacuna;								
	api.PonistiPripremuZaFiskalizaciju = PonistiPripremuZaFiskalizaciju;
	api.KPZaglavObrisi = KPZaglavObrisi;
	api.KPStavkeObrisi = KPStavkeObrisi;
	api.GetKPStavkeFields = GetKPStavkeFields;
	api.KPStavkeSetAfterPolje = KPStavkeSetAfterPolje;
	api.TraziASpojen = TraziASpojen;
	api.RRateSetAfterPolje = RRateSetAfterPolje;
	api.RRateRasporedSetAfterPolje = RRateRasporedSetAfterPolje;
	api.RRateUskladiRacunIRate = RRateUskladiRacunIRate;
	api.DStavkeOdustaniOdIsporuke = DStavkeOdustaniOdIsporuke;
	api.ProvjeraDokumentaKojiIsporucuje = ProvjeraDokumentaKojiIsporucuje;
	api.GetDSerFields = GetDSerFields;
	api.GetDSerSifarnikCaption = GetDSerSifarnikCaption;
	api.GetDSerBrisanjePitanje = GetDSerBrisanjePitanje;
	api.DSerObrisi = DSerObrisi;
	api.PrijenosUgovoraSKupcima = PrijenosUgovoraSKupcima;
	api.PredloziZatvaranjeRacunaEnabled = PredloziZatvaranjeRacunaEnabled;
	api.PredloziUplatu = PredloziUplatu;
	api.KZaglavImaUDigitalnojArhivi = KZaglavImaUDigitalnojArhivi;	
	api.KStavkeCopy = KStavkeCopy;
	api.KStavkePaste = KStavkePaste;	
	api.KStavkeSetAfterPolje = KStavkeSetAfterPolje;
	api.GetArtiklNazivJM = GetArtiklNazivJM;
	api.CStavkeCopy = CStavkeCopy;
	api.CStavkePaste = CStavkePaste;	
	api.OtpremNaRacunPitanjePrijeUpisa = OtpremNaRacunPitanjePrijeUpisa;
	api.OtpremNaRacunUpisiUPozadini = OtpremNaRacunUpisiUPozadini;
								
	function ABarKodObrisi(godina,artikl,abarkod){
		return $.dsDirectCall({
			method: "ABarKodObrisi",
			params: [ godina, artikl, abarkod ]
		});
	}
	
	function ABarKodGetLabelCaption(godina,artikl,abarkod){
		return $.dsDirectCall({
			method: "ABarKodGetLabelCaption",
			params: [ godina, artikl, abarkod ]
		});
	}
	
	function GetArtiklNazivJM(godina,artikl){
		return $.dsDirectCall({
			method: "GetArtiklNazivJM",
			params: [ godina, artikl ]
		});
	}
	
	function GetGodinaSkladisteVpDokumNaziv(dZaglav){ //cijeli objekt dZaglav
		return $.dsDirectCall({
			method: "GetGodinaSkladisteVpDokumNaziv",
			params: [ dZaglav ]
		});	
	}
	
	function GetDStavkeFields(godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna){
		return $.dsDirectCall({
			method: "GetDStavkeFields",
			params: [ godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna ]
		});
	}
	
	function ArtiklById(godina, idArtikl){ //cijeli objekt dStavke
		return $.dsDirectCall({
			method: "ArtiklById",
			params: [godina, idArtikl]
		});
	}
	
	function GetDisplayStanja(dStavke){
		return $.dsDirectCallPost({
			method: "GetDisplayStanja",
			controller: "dstavke",
			data: [dStavke]
		});		
	}
	
	function GetDStavkeBrisanjeInteract(godina, skladiste, stavkeList){
		return $.dsDirectCall({
			method: "GetDStavkeBrisanjeInteract",
			params: [ godina, skladiste, stavkeList, false]
		});	
	}
	
	function GetDStavkeRacunBrisanjeInteract(godina, vrsta, racun, stavkeList){
		return $.dsDirectCall({
			method: "GetDStavkeRacunBrisanjeInteract",
			params: [ godina, vrsta, racun, stavkeList ]
		});	
	}
	
	function DStavkeObrisi(godina, skladiste, vpDokum, broj, stavka){
		return $.dsDirectCall({
			method: "DStavkeObrisi",
			params: [ godina, skladiste, vpDokum, broj, stavka ]
		});		
	}
	
	function DStavkeObrisiList(godina, skladiste, vpDokum, broj, stavkeList, bPozivIZRacuna, bNapravitiZapisnikPC){
		return $.dsDirectCall({
			method: "DStavkeObrisiList",
			params: [ godina, skladiste, vpDokum, broj, stavkeList, bPozivIZRacuna, bNapravitiZapisnikPC ]
		});		
	}
	
	function DStavkeCopy(godina, skladiste, vpDokum, broj, stavkeList){
		return $.dsDirectCall({
			method: "DStavkeCopy",
			params: [ godina, skladiste, vpDokum, broj, stavkeList ]
		});		
	}
	
	function DStavkePaste(godina, skladiste, vpDokum, broj, pozivIzRacuna, vrsta, racun){
		return $.dsDirectCall({
			method: "DStavkePaste",
			params: [ godina, skladiste, vpDokum, broj, pozivIzRacuna, vrsta, racun ]
		});		
	}
	
	function DopustenoNastimavanjePoreza(godina, skladiste, vpDokum, broj, stavka){
		return $.dsDirectCall({
			method: "DopustenoNastimavanjePoreza",
			params: [ godina, skladiste, vpDokum, broj, stavka ]
		});	
	}
	
	function NastimajPorez(godina, skladiste, vpDokum, broj, stavka, lipa){
		return $.dsDirectCall({
			method: "NastimajPorez",
			params: [ godina, skladiste, vpDokum, broj, stavka, lipa ]
		});	
	}
	
	function GetDZaglavBrisanjePitanje(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetDZaglavBrisanjePitanje",
			params: [ godina, skladiste, vpDokum, broj ]
		});	
	}	
	
	function DZaglavObrisi(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "DZaglavObrisi",
			params: [ godina, skladiste, vpDokum, broj ]
		});		
	}
	
	function DZaglavGenerirajZahtINarIzRdn(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "DZaglavGenerirajZahtINarIzRdn",
			params: [ godina, skladiste, vpDokum, broj ]
		});		
	}	
	
	function AGrupa1Obrisi(godina, aGrupa1){
		return $.dsDirectCall({
			method: "AGrupa1Obrisi",
			params: [ godina, aGrupa1 ]
		});
	}
	
	function AsortimanObrisi(asortiman){
		return $.dsDirectCall({
			method: "AsortimanObrisi",
			params: [ asortiman ]
		});
	}
	
	function ModelObrisi(model){
		return $.dsDirectCall({
			method: "ModelObrisi",
			params: [ model ]
		});
	}
	
	function VoziloObrisi(vozilo){
		return $.dsDirectCall({
			method: "VoziloObrisi",
			params: [ vozilo ]
		});
	}
	
	function VoziloGetLabelCaption(vozilo){
		return $.dsDirectCall({
			method: "VoziloGetLabelCaption",
			params: [ vozilo ]
		});		
	}
	
	function PlacenoObrisi(godina, placeno){
		return $.dsDirectCall({
			method: "PlacenoObrisi",
			params: [ godina, placeno ]
		});
	}
	
	function GetPlacRateFields(godina, placeno){
		return $.dsDirectCall({
			method: "GetPlacRateFields",
			params: [ godina, placeno ]	
		});
	}
	
	function GetCStavkeFields(tip, cjenik, odabirIzCjenika){
		return $.dsDirectCall({
			method: "GetCStavkeFields",
			params: [ tip, cjenik, odabirIzCjenika ] 
		});
	}
	
	function CStavkeKontrolaGrupaArtikala(godina, tip, cjenik){
		return $.dsDirectCall({
			method: "CStavkeKontrolaGrupaArtikala",
			params: [ godina, tip, cjenik ] 
		});	
	}
	
	function CjenikSeUnosiPrekoAG1(tip){
		return $.dsDirectCall({
			method: "CjenikSeUnosiPrekoAG1",
			params: [ tip ]
		});
	}
	
	function ProvjeraPreklapanjaStavki(godina, tip, cjenik, stavka, samoOvaStavka){
		return $.dsDirectCall({
			method: "ProvjeraPreklapanjaStavki",
			params: [ godina, tip, cjenik, stavka, samoOvaStavka ]
		});
	}
	
	function UpisPremaPrvojStavci(godina, tip, cjenik, stavkeList){
		return $.dsDirectCall({
			method: "UpisPremaPrvojStavci",
			params: [ godina, tip, cjenik, stavkeList ]
		});
	}
	
	function CStavkeGetPopisPoljaZaPrikaz(obj, novi){
		return $.dsDirectCall({
			method: "CStavkeGetPopisPoljaZaPrikaz",
			params: [ obj, novi ]
		});	
	}
	
	function CjenikGetPopisPoljaZaPrikaz(obj, novi, kopiranjeCjenika, kopiranjeSamoStavki){
		return $.dsDirectCall({
			method: "CjenikGetPopisPoljaZaPrikaz",
			params: [ obj, novi, kopiranjeCjenika, kopiranjeSamoStavki ]
		});	
	}
	
	function CjenikObrisi(godina, tip, cjenik){
		return $.dsDirectCall({
			method: "CjenikObrisi",
			params: [ godina, tip, cjenik ]
		});
	}
	
	function CParGetPopisPoljaZaPrikaz(obj, novi){
		return $.dsDirectCall({
			method: "CParGetPopisPoljaZaPrikaz",
			params: [ obj, novi ]
		});	
	}
	
	function CParPartneriZaSkupnoFakturiranjeWarrning(obj){
		return $.dsDirectCall({
			method: "CParPartneriZaSkupnoFakturiranjeWarrning",
			params: [ obj ]
		});
	}	
	
	function CParObrisi(godina, partner, tip, cjenik, stavka){
		return $.dsDirectCall({
			method: "CParObrisi",
			params: [ godina, partner, tip, cjenik, stavka ]
		});
	}
	
			
	function DStavkeSetAfterPolje(polje, pozivIzRacuna,dStavke, errorOverride){
			return $.dsDirectCallPost({
				method: "DStavkeSetAfterPolje",
				controller: "dstavke",
				params: [ polje, pozivIzRacuna ],
				data: [ dStavke ],
				fail: function (error, textStatus, jqXHR, logicalError){ 
				    KUtils.busy(false);
					if (errorOverride){
						jqXHR.statusText = "errorOverride"; 
					}
					//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
				}
			});			
	}
	
	function OdjavaSSetAfterPolje(polje, novi, odjavaS, errorOverride){
		return $.dsDirectCallPost({
			method: "OdjavaSSetAfterPolje",
			controller: "odjavas",
			params: [ polje, novi ],
			data: [ odjavaS ],
			fail: function (error, textStatus, jqXHR, logicalError){
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});	
	}
	
	function DZaglavSetAfterPolje(polje, dZaglav, errorOverride){
		return $.dsDirectCallPost({
			method: "DZaglavSetAfterPolje",
			controller: "dzaglav",	
			params: [ polje ],			
			data: [ dZaglav ],					
			fail: function (error, textStatus, jqXHR, logicalError){
			    KUtils.busy(false); 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}
	
	function CStavkeObrisi(godina, tip, cjenik, stavka){
		return $.dsDirectCall({
			method: "CStavkeObrisi",
			params: [ godina, tip, cjenik, stavka ]
		});
	}
	
	function DZaglavImaUDigitalnojArhivi(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "DZaglavImaUDigitalnojArhivi",
			params: [ godina, skladiste, vpDokum, broj ]
		});			
	}	
	
	function VpStatusDigitalnoArhivirati(vpStatus){
		return $.dsDirectCall({
			method: "VpStatusDigitalnoArhivirati",
			params: [ vpStatus ]
		});			
	}	

	function GetDZaglavZakljucan(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetDZaglavZakljucan",
			params: [ godina, skladiste, vpDokum, broj ]
		});
	}
	
	function GetDZaglavNoviCaptionByPK(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetDZaglavNoviCaptionByPK",
			params: [ godina, skladiste, vpDokum, broj ]
		});	
	}
	
	function VpOrganPObrisi(vpOrganP){
		return $.dsDirectCall({
			method: "VpOrganPObrisi",
			params: [ vpOrganP ]
		});
	}
	
	function VpStatusPObrisi(vpStatusP){
		return $.dsDirectCall({
			method: "VpStatusPObrisi",
			params: [ vpStatusP ]
		});
	}
	
	function GetGodinaZaPozicijuIzvore(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetGodinaZaPozicijuIzvore",
			params: [ godina, skladiste, vpDokum, broj ]
		});	
	}
	
	function InitMogucePromjeneVpStatusa(vpStatusVrsta, godina, skladiste, vpDokum, broj){
		if (vpDokum == undefined) vpDokum = 0;
		if (vpDokum == undefined) broj= 0;
		return $.dsDirectCall({
			method: "InitMogucePromjeneVpStatusa",
			params: [ vpStatusVrsta, godina, skladiste, vpDokum, broj ]
		});			
	}
	
	function MogucaPromjenaVpStatusa(vpStatusVrsta, godina, skladiste, vpDokum, broj, odjava, vpStatus, vrsta, racun, vrstaKal, kalkulacija){
		return $.dsDirectCall({
			method: "MogucaPromjenaVpStatusa",
			params: [vpStatusVrsta, godina, skladiste, vpDokum, broj, odjava, vpStatus, vrsta, racun, vrstaKal, kalkulacija ]
		});		
	}	
	
	function PromijeniVpStatus(vpStatusVrsta, godina, skladiste, brojeviDokumenata, vpDokum, odjava, vpStatus, opis, vrsta, racun, vrstaKal, kalkulacija){
		return $.dsDirectCall({
			method: "PromijeniVpStatus",
			params: [vpStatusVrsta, godina, skladiste, brojeviDokumenata, vpDokum, odjava, vpStatus, opis, vrsta, racun, vrstaKal, kalkulacija ]
		});			
	}
	
	function VpStatusGetObavijest(vpStatus){
		return $.dsDirectCall({
			method: "VpStatusGetObavijest",
			params: [ vpStatus ]
		});
	}
	
	function KontoRizById(id, tablica, godina, skladiste, vpDokum, broj){
		if (skladiste == undefined) skladiste = '';
		if (vpDokum == undefined) vpDokum = 0;
		if (broj == undefined) broj = 0;
		return $.dsDirectCall({
			method: "KontoRizById",
			params: [ id, tablica, godina, skladiste, vpDokum, broj ]
		});
	}
	
	function GetUpozorenjeOPartneruZaNoviProdajniIliPredprodajniDokument(partner){
		return $.dsDirectCall({
			method: "GetUpozorenjeOPartneruZaNoviProdajniIliPredprodajniDokument",
			params: [ partner ]
		});	
	}
	
	function PartnerJeMaticni(partner){
		return $.dsDirectCall({
			method: "PartnerJeMaticni",
			params: [ partner ]
		});	
	}
	
	function GetArtiklAfterA2Grupa1(godina, a2Grupa1){
		return $.dsDirectCall({
			method: "GetArtiklAfterA2Grupa1",
			params: [ godina, a2Grupa1 ]
		});		
	}
	
	function ArtiklValidate(novi, godina, artikl, agrupa1){
		return $.dsDirectCall({
			method: "ArtiklValidate",
			params: [ novi, godina, artikl, agrupa1 ]
		});		
	}
	
	function ArtiklGetNovaSifra(godina){
		return $.dsDirectCall({
			method: "ArtiklGetNovaSifra",
			params: [ godina ]
		});		
	}
	
	function RjesenjeById(rjesenjeId){
		return $.dsDirectCall({
			method: "RjesenjeById",
			params: [ rjesenjeId ]
		});		
	}
	
	function OdjavaPopuni(godina, skladiste, odjava, naravnatiRazlike){
		return $.dsDirectCall({
			method: "OdjavaPopuni",
			params: [ godina, skladiste, odjava, naravnatiRazlike ]
		});
	}
	
	function GetOdjavaSFields(godina, skladiste, odjava){
		return $.dsDirectCall({
			method: "GetOdjavaSFields",
			params: [ godina, skladiste, odjava ]
		});
	}
	
	function GetOdjavaSArtiklDodatno(artikl, godina){
		return $.dsDirectCall({
			method: "GetOdjavaSArtiklDodatno",
			params: [ artikl, godina ]
		});	
	}
	
	function GetInvenSFields(godina, skladiste, inven, list){
		return $.dsDirectCall({
			method: "GetInvenSFields",
			params: [ godina, skladiste, inven, list ]
		});
	}
	
	function InvenObrisi(godina, skladiste, inven){
		return $.dsDirectCall({
			method: "InvenObrisi",
			params: [ godina, skladiste, inven ]
		});
	}	
	
	function InvenSSetAfterPolje(polje, invens, errorOverride){
			return $.dsDirectCallPost({
				method: "InvenSSetAfterPolje",
				controller: "invens",
				params: [ polje ],
				data: [ invens ],
				fail: function (error, textStatus, jqXHR, logicalError){ 
					if (errorOverride){
						jqXHR.statusText = "errorOverride"; 
					}
					//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
				}
			});			
	}
	
	/*function InvenSSetAfterPolje(polje, invenS){			
		return $.dsDirectCall({
			method: "InvenSSetAfterPolje",
			params: [ polje, invenS ]
		});			
	}*/
	
	function InvenSObrisi(godina, skladiste, inven, list, stavka){
		return $.dsDirectCall({
			method: "InvenSObrisi",
			params: [ godina, skladiste, inven, list, stavka ]
		});
	}
	
	function GetInvenLFields(godina, skladiste, inven){
		return $.dsDirectCall({
			method: "GetInvenLFields",
			params: [ godina, skladiste, inven ]
		});
	}
	
	function InvenLObrisi(godina, skladiste, inven, list){
		return $.dsDirectCall({
			method: "InvenLObrisi",
			params: [ godina, skladiste, inven, list ]
		});
	}

	function DohvatiIznoseDStavke(godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna){
		return $.dsDirectCall({
			method: "DohvatiIznoseDStavke",
			params: [ godina, skladiste, vpDokum, broj, vrsta, racun, pozivIzRacuna ]
		});		
	}
		
	function GetDZagDZagDokumentiCaption(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetDZagDZagDokumentiCaption",
			params: [ godina, skladiste, vpDokum, broj ]
		});	
	}
	
	function UpisiVpOvlastenjaZaVrstaGrupaKor(vrsta, lista, GrupaKorList){
		return $.dsDirectCall({
			method: "UpisiVpOvlastenjaZaVrstaGrupaKor",
			params: [ vrsta, lista, GrupaKorList ]
		});		
	}
	
	function ProvjeraPreklapaSe(cjenik, godina, tip, artikl, agrupa1, opcije){
		return $.dsDirectCall({
			method: "ProvjeraPreklapaSe",
			params: [ cjenik, godina, tip, artikl, agrupa1, opcije ]
		});	
	};
	
	function MPCijenaValidate(objects, novi){
		return $.dsDirectCallPost({
			method: "MPCijenaValidate",
			controller: "artikl",
			params: [ novi ],
			data: [ objects ]
		});	
	}
	function DohvatiNaplatneUredjaje(godina, skladiste, vrsta){
		return $.dsDirectCall({
			method: "DohvatiNaplatneUredjaje",
			params: [ godina, skladiste, vrsta ]
		});	
	};
		
	function SetPCijenaAfterMPCijena( mpCijena, porez){
		return $.dsDirectCall({
			method: "SetPCijenaAfterMPCijena",
			params: [ mpCijena, porez ]
		});	
	};
	
	function GetNapomena2KontoRiznica(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetNapomena2KontoRiznica",
			params: [ godina, skladiste, vpDokum, broj ]
		});		
	}
	
	function DefaultNaplatniRacun(godina, skladiste, vrsta){
		return $.dsDirectCall({
			method: "DefaultNaplatniRacun",
			params: [ godina, skladiste, vrsta ]
		});	
	};	
	
	function GetDStavkeRacunSifarnikCaption(godina, skladiste, vrsta, racun){
		return $.dsDirectCall({
			method: "GetDStavkeRacunSifarnikCaption",
			params: [ godina, skladiste, vrsta, racun ]
		});	
	};		
	
	function CStavkeUpisUArtikl(sveStavke, godina, tip, cjenik, stavka) {
		return $.dsDirectCall({
			method:"CStavkeUpisUArtikl",
			params: [sveStavke, godina, tip, cjenik, stavka]
		});
	};
	
	function CStavkeSetAfterPolje(polje, novi, cStavke, errorOverride){
			return $.dsDirectCallPost({
				method: "CStavkeSetAfterPolje",
				controller: "cstavke",
				params: [ polje, novi ],
				data: [ cStavke ],
				fail: function (error, textStatus, jqXHR, logicalError){ 
				    KUtils.busy(false);
					if (errorOverride){
						jqXHR.statusText = "errorOverride"; 
					}
					//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
				}
			});			
	}
	
	function SetAfterCParOdabir(sGodina, iVpDokum, iPartner, sTip, iCjenik, iStavka) {
		return $.dsDirectCall({
			method:"SetAfterCParOdabir",
			params: [sGodina, iVpDokum, iPartner, sTip, iCjenik, iStavka]
		});
	};
	
   function ZakljucanPoVpStatusu(godina, skladiste, vpDokum, broj) {
		return $.dsDirectCall({
			method:"ZakljucanPoVpStatusu",
			params: [godina, skladiste, vpDokum, broj]
		});
	};
	
	function DStavkeUpisUArtikl(sveStavke, godina, skladiste, vpDokum, broj, stavka) {
		return $.dsDirectCall({
			method:"DStavkeUpisUArtikl",
			params: [sveStavke, godina, skladiste, vpDokum, broj, stavka]
		});
	};
	
	function DZaglavIzmijeniBiljesku(godina, skladiste, vpDokum, broj, napomena){ 
		return $.dsDirectCall({
			method: "DZaglavIzmijeniBiljesku",
			params: [ godina, skladiste, vpDokum, broj, napomena ]
		});	
	};		
	
	function RacunIzmijeniBiljesku(godina, vrsta, racun, napomena){ 
		return $.dsDirectCall({
			method: "RacunIzmijeniBiljesku",
			params: [ godina, vrsta, racun, napomena ]
		});	
	};	
	
	function VpOvlastenjeObrisi(vpOvlastenje){
		return $.dsDirectCall({
			method: "VpOvlastenjeObrisi",
			params: [ vpOvlastenje ]
		});	
	}
	
	//POST
	function DohvatiPitanjeZaPrijepisStanja(izvjestajParams) {
		return $.dsDirectCallPost({
			method:"DohvatiPitanjeZaPrijepisStanja",
			controller: "izvjestaji",		
			data: [izvjestajParams]
		});
	};	
	
	//POST		
	function DStavkeUpisiArtikleSaStanja(izvjestajParams) {
		return $.dsDirectCallPost({
			method:"DStavkeUpisiArtikleSaStanja",
			controller: "izvjestaji",		
			data: [izvjestajParams]
		});				
	};
		
	function DohvatiPostoMarzeDStavke(godina, vrsta, racun){
		return $.dsDirectCall({
			method:"DohvatiPostoMarzeDStavke",		
			params: [ godina, vrsta, racun ]
		});	
	}
	
	function DohvatiMasuAOpisDStavke(godina, vrsta, racun){
		return $.dsDirectCall({
			method:"DohvatiMasuAOpisDStavke",		
			params: [ godina, vrsta, racun ]
		});	
	}	
	
	function GetKolicineDStavke(godina, skladiste, vpDokum, broj){
		return $.dsDirectCall({
			method: "GetKolicineDStavke",
			params: [ godina, skladiste, vpDokum, broj ]
		});		
	}	
		
	function RacunSetAfterPolje(polje, racun, novi, errorOverride){
		return $.dsDirectCallPost({
			method: "RacunSetAfterPolje",
			controller: "racun",
			params: [ polje, novi ],
			data: [ racun ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});	
	}	
		
	function SljedecaGodinaEnabled(rizDok, rUgovor){ 
		return $.dsDirectCall({
			method: "SljedecaGodinaEnabled",
			params: [ rizDok, rUgovor ]
		});	
	};
	
	function GetRjRedakTekst(rjesenje){ 
		return $.dsDirectCall({
			method: "GetRjRedakTekst",
			params: [ rjesenje ]
		});	
	};
	
	function RacunProvjeriVAT(partner){
		return $.dsDirectCall({
			method: "RacunProvjeriVAT",
			params: [partner]
		});
	}
	
	function GetKZaglavBrisanjePitanje(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "GetKZaglavBrisanjePitanje",
			params: [ godina, vrsta, kalkulacija ]
		});	
	}
	
	function KZaglavObrisi(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "KZaglavObrisi",
			params: [ godina, vrsta, kalkulacija ]
		});		
	}
	
	function GetKStavkeFields(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "GetKStavkeFields",
			params: [ godina, vrsta, kalkulacija ]
		});
	}	
	
	function GetKZaglavZakljucan(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "GetKZaglavZakljucan",
			params: [ godina, vrsta, kalkulacija ]
		});
	}	
	
	function KStavkeObrisiList(godina, vrsta, kalkulacija, stavkeList){
		return $.dsDirectCall({
			method: "KStavkeObrisiList",
			params: [ godina, vrsta, kalkulacija, stavkeList ]
		});		
	}	
	
	function GetKolicineKStavke(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "GetKolicineKStavke",
			params: [ godina, vrsta, kalkulacija ]
		});		
	}
	
	function RacunImaUDigitalnojArhivi(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "RacunImaUDigitalnojArhivi",
			params: [ godina, vrsta, racun ]
		});			
	}	
			
	function GetRacunZakljucan(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "GetRacunZakljucan",
			params: [ godina, vrsta, racun ]
		});
	}
	
	function DStavkeRacunObrisiList(godina, vrsta, racun, stavkeList, bNapravitiZapisnikPC){
		return $.dsDirectCall({
			method: "DStavkeRacunObrisiList",
			params: [ godina, vrsta, racun, stavkeList, bNapravitiZapisnikPC ]
		});		
	}
	
	function GetERacunPitanjeSlanje(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "GetERacunPitanjeSlanje",
			params: [ godina, vrsta, racun ]
		});		
	}
	function PodaciZaEdiVisible(partner){
		return $.dsDirectCall({
			method: "PodaciZaEdiVisible",
			params: [ partner ]
		});
	}	
	
	function ERacunJeMogucePoslati(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunJeMogucePoslati",
			params: [ godina, vrsta, racun ]
		});
	}	
		
	function GetERacunPriviciIzDA(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "GetERacunPriviciIzDA",
			params: [ godina, vrsta, racun ]
		});
	}
	
	function PosaljiERacunVp(forma, errorOverride){
		return $.dsDirectCallPost({
			method: "PosaljiERacunVp",
			controller: "iracun",	
			data: [ forma ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}	
	
	function GetERacunPitanjeMultiSlanje(forma, errorOverride){
		return $.dsDirectCallPost({
			method: "GetERacunPitanjeMultiSlanje",
			controller: "iracun",	
			data: [ forma ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				KUtils.busy(false);
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}
		});
	}		
	
	function AzurirajParametreZaSlanjePremaPodacimaUPartneruClick(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "AzurirajParametreZaSlanjePremaPodacimaUPartneruClick",
			params: [ godina, vrsta, racun ]
		});
	}
		
	function ERacunProvjeraStatusa(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunProvjeraStatusa",
			params: [ godina, vrsta, racun ]
		});
	}
	
	function ERacunPrisilnoSlanje(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunPrisilnoSlanje",
			params: [ godina, vrsta, racun ]
		});
	}	
	
	function GetRacunBrisanjePitanje(godina, vrsta, naplatni, listaRacuna){
		return $.dsDirectCall({
			method: "GetRacunBrisanjePitanje",
			params: [ godina, vrsta, naplatni, listaRacuna ]
		});
	}	
	
	function RacunMultiBrisanje(godina, vrsta, listaRacuna){
		return $.dsDirectCall({
			method: "RacunMultiBrisanje",
			params: [ godina, vrsta, listaRacuna ]
		});
	}		
		
	function RacunBrisanjeList(godina, vrsta, listaRacuna){
		return $.dsDirectCall({
			method: "RacunBrisanjeList",
			params: [ godina, vrsta, listaRacuna ]
		});
	}		
				
	function ERacunOpoziv(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunOpoziv",
			params: [ godina, vrsta, racun ]
		});
	}	
	
	function ERacunPonistiOznakuERacunPoslan(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunPonistiOznakuERacunPoslan",
			params: [ godina, vrsta, racun ]
		});
	}	
		
	function ERacunPosaljiPrimateljuObavijestOPrimljenomERacunu(godina, vrsta, racun, eracunstatus){
		return $.dsDirectCall({
			method: "ERacunPosaljiPrimateljuObavijestOPrimljenomERacunu",
			params: [ godina, vrsta, racun, eracunstatus ]
		});
	}	
	
	function ERacunIskljuciSlanjeERacunaZaTrenutniRacun(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunIskljuciSlanjeERacunaZaTrenutniRacun",
			params: [ godina, vrsta, racun ]
		});
	}
	
	function ERacunOznaciDaJeRacunDostavljen(godina, vrsta, racun){
		return $.dsDirectCall({
			method: "ERacunOznaciDaJeRacunDostavljen",
			params: [ godina, vrsta, racun ]
		});
	}	
	
	function ERacunProvjeraStatusaZaRazdoblje(data, errorOverride){
		return $.dsDirectCallPost({
			method: "ERacunProvjeraStatusaZaRazdoblje",
			controller: "racun",			
			data: [ data ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}			
		});
	}	
	
	function ERacunProvjeriStatusVpRacunRazdoblje(godina, vrsta, naplatni, datum1Od, datum1Do){
		return $.dsDirectCall({
			method: "ERacunProvjeriStatusVpRacunRazdoblje",
			params: [ godina, vrsta, naplatni, datum1Od, datum1Do ]
		});
	}	
	
	function MoguceKopiranjeRacuna(godina, skladiste, vrsta, naplatni, racunOtpremnica, racunId, storniraj){
		return $.dsDirectCall({
			method: "MoguceKopiranjeRacuna",
			params: [ godina, skladiste, vrsta, naplatni, racunOtpremnica, racunId, storniraj ]
		});
	}	
	
	function RacunValidate(racun, naplatni, novi, errorOverride){
		return $.dsDirectCallPost({
			method: "RacunValidate",
			params: [ naplatni, novi ],
			controller: "racun",			
			data: [ racun ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
			}				
		});
	}
	
	function RacunFiskalizacijaOznacenogRacuna(godina, skladiste, vrsta, racun, fiskalizacija){
		return $.dsDirectCall({
			method: "RacunFiskalizacijaOznacenogRacuna",		
			params: [ godina, skladiste, vrsta, racun, fiskalizacija ]			
		});
	}	
	
	function PripremiRacunZaFiskalizaciju(godina, skladiste, vrsta, racun, fiskalizacija){
		return $.dsDirectCall({
			method: "PripremiRacunZaFiskalizaciju",		
			params: [ godina, skladiste, vrsta, racun, fiskalizacija ]			
		});
	}		
	
	function GetListaNefiskaliziranihRacuna(godina, skladiste, vrsta){
		return $.dsDirectCall({
			method: "GetListaNefiskaliziranihRacuna",		
			params: [ godina, skladiste, vrsta ]			
		});
	}	
		
	function PonistiPripremuZaFiskalizaciju(godina, skladiste, vrsta, racun){
		return $.dsDirectCall({
			method: "PonistiPripremuZaFiskalizaciju",		
			params: [ godina, skladiste, vrsta, racun ]			
		});
	}
	
	function KPZaglavObrisi(godina, skladiste, mpdokum, kpopisa){
		return $.dsDirectCall({
			method: "KPZaglavObrisi",
			params: [ godina, skladiste, mpdokum, kpopisa ]
		});		
	}
	
	function KPStavkeObrisi(godina, skladiste, mpdokum, kpopisa, porez){
		return $.dsDirectCall({
			method: "KPStavkeObrisi",
			params: [ godina, skladiste, mpdokum, kpopisa, porez ]
		});		
	}
	
	function GetKPStavkeFields(godina, skladiste, mpdokum, kpopisa, zadraz){
		return $.dsDirectCall({
			method: "GetKPStavkeFields",
			params: [ godina, skladiste, mpdokum, kpopisa, zadraz ] 
		});
	}	
	
	function KPStavkeSetAfterPolje(polje, zadRaz, novi, kpstavke, errorOverride){
		return $.dsDirectCallPost({
			method: "KPStavkeSetAfterPolje",
			controller: "kpstavke",
			params: [ polje, zadRaz, novi ],
			data: [ kpstavke ],
			fail: function (error, textStatus, jqXHR, logicalError){ 
				if (errorOverride){
					jqXHR.statusText = "errorOverride"; 
				}
				//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
			}
		});	
	}	
	
	function TraziASpojen(godina, skladiste, artikl, spojiInven, inventura){
        return $.dsDirectCall({
            method: "TraziASpojen",
            params: [ godina, skladiste, artikl, spojiInven, inventura ] 
        });
    }   
    
    function RRateSetAfterPolje(polje, rrate, errorOverride){
        return $.dsDirectCallPost({
            method: "RRateSetAfterPolje",
            controller: "rrate",
            params: [ polje ],
            data: [ rrate ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        }); 
    } 
	
	function RRateUskladiRacunIRate(godina, vrsta, racun){
        return $.dsDirectCall({
            method: "RRateUskladiRacunIRate",
            params: [ godina, vrsta, racun ] 
        });	
    }
	
    function RRateRasporedSetAfterPolje(polje, rrateRaspored, errorOverride){
        return $.dsDirectCallPost({
            method: "RRateRasporedSetAfterPolje",
            controller: "rrate",
            params: [ polje ],
            data: [ rrateRaspored ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
                //ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
            }
        }); 
    }
    
	function DStavkeOdustaniOdIsporuke(godina, skladiste, vpDokum, broj, stavka){
		return $.dsDirectCall({
			method: "DStavkeOdustaniOdIsporuke",
			params: [ godina, skladiste, vpDokum, broj, stavka ]
		});			
	}	    
    
	function ProvjeraDokumentaKojiIsporucuje(godina, skladiste, vpDokum, broj, stavka, ulaz, izlaz, razduzeno, vraceno){
		return $.dsDirectCall({
			method: "ProvjeraDokumentaKojiIsporucuje",
			params: [ godina, skladiste, vpDokum, broj, stavka, ulaz, izlaz, razduzeno, vraceno ]
		});			
	}	    
	
	function GetDSerFields(godina, skladiste, vpDokum, broj, stavka){
		return $.dsDirectCall({
			method: "GetDSerFields",
			params: [ godina, skladiste, vpDokum, broj, stavka ]
		});
	}	
	
	function GetDSerSifarnikCaption(godina, vpDokum, broj, artikl, pozivIzRacuna){
		return $.dsDirectCall({
			method: "GetDSerSifarnikCaption",
			params: [ godina, vpDokum, broj, artikl, pozivIzRacuna ]
		});
	}		
    
	function GetDSerBrisanjePitanje(redni){
		return $.dsDirectCall({
			method: "GetDSerBrisanjePitanje",
			params: [ redni ]
		});
	}	
	
	function DSerObrisi(godina, skladiste, vpDokum, broj, stavka, redni){
		return $.dsDirectCall({
			method: "DSerObrisi",
			params: [ godina, skladiste, vpDokum, broj, stavka, redni ]
		});
	}			
	
	function PrijenosUgovoraSKupcima(godina, vrsta, listaRacuna, godinaU){
		return $.dsDirectCall({
			method: "PrijenosUgovoraSKupcima",
			params: [ godina, vrsta, listaRacuna, godinaU ]
		});		
	}		
	
	function PredloziZatvaranjeRacunaEnabled(vrsta, opcije){
		return $.dsDirectCall({
			method: "PredloziZatvaranjeRacunaEnabled",
			params: [ vrsta, opcije ]
		});		
	}	
	
	function PredloziUplatu(godina, opcije, vrsta2, racun, povratnica, racun2){
		return $.dsDirectCall({
			method: "PredloziUplatu",
			params: [ godina, opcije, vrsta2, racun, povratnica, racun2 ]
		});
	}	
	
	function KZaglavImaUDigitalnojArhivi(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "KZaglavImaUDigitalnojArhivi",
			params: [ godina, vrsta, kalkulacija ]
		});			
	}	
	
	function KStavkeCopy(godina, vrsta, kalkulacija, stavkeList){
		return $.dsDirectCall({
			method: "KStavkeCopy",
			params: [ godina, vrsta, kalkulacija, stavkeList ]
		});		
	}
	
	function KStavkePaste(godina, vrsta, kalkulacija){
		return $.dsDirectCall({
			method: "KStavkePaste",
			params: [ godina, vrsta, kalkulacija ]
		});		
	}	
	    
	function KStavkeSetAfterPolje(polje, kStavke, errorOverride){
			return $.dsDirectCallPost({
				method: "KStavkeSetAfterPolje",
				controller: "kstavke",
				params: [ polje ],
				data: [ kStavke ],
				fail: function (error, textStatus, jqXHR, logicalError){ 
					if (errorOverride){
						jqXHR.statusText = "errorOverride"; 
					}
					//ako nije uhvatit će ga $(document).ajaxError(KUtils.defaultAjaxErrorHandler); na main-template.tpl
				}
			});			
	}

	function CStavkeCopy(godina, tip, cjenik, stavkeList){
		return $.dsDirectCall({
			method: "CStavkeCopy",
			params: [ godina, tip, cjenik, stavkeList ]
		});		
	}
	
	function CStavkePaste(godina, tip, cjenik){
		return $.dsDirectCall({
			method: "CStavkePaste",
			params: [ godina, tip, cjenik ]
		});		
	}	
	
	function OtpremNaRacunPitanjePrijeUpisa(otpremNaRacun){			
		return $.dsDirectCall({
			method: "OtpremNaRacunPitanjePrijeUpisa",
			params: [ otpremNaRacun ]
		});
	}
	
	function OtpremNaRacunUpisiUPozadini(otpremNaRacun){			
		return $.dsDirectCall({
			method: "OtpremNaRacunUpisiUPozadini",
			params: [ otpremNaRacun ]
		});
	}
		    
} (konto.vp.api = {}));